<template lang='pug'>
EventToProp(
  v-slot='{ prop: loading, updateProp: loadingUpdate }'
)
  v-dialog(
    :value='loading'
    fullscreen
    no-click-animation
    persistent
    transition='fade-transition'
  )
    v-progress-linear(
      indeterminate
      color='primary'
    )
  slot(
    v-if='shouldRenderSlot'
    :start='() => loadingUpdate(true)'
    :stop='() => loadingUpdate(false)'
  )
</template>

<script>
import EventToProp from './EventToProp.vue';

function mounted()
{
  this.shouldRenderSlot = true;
}

export default
{
  components:
  {
    EventToProp
  },
  data()
  {
    return {
      shouldRenderSlot: false
    };
  },
  mounted,
};
</script>